export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.26-1603.02",
  commitId: "d6ff091bfc11c247c46106799be0f8b008ab4e81",
  commitTime: "2026-05-26T16:03:02.000Z",
});
